import { FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable()
export class ValidationService {
  constructor() {}

  static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    const config: any = {
      required: `は、必須です。`,
      // 'invalidEmailAddress': 'Invalid email address',
      // 'invalidPassword': 'Invalid password. Password must be at least 6 characters long, and contain a number.',
      maxlength: `は、10文字までです`,
      invalidAlphaNumeric: `は、アルファベットか数値です。`
    };

    return config[validatorName];
  }

  static alphanumericValidator(control: FormControl): { [s: string]: boolean } {
    if (control.value.match(/^[a-zA-Z0-9_]*$/)) {
      return null;
    } else {
      return { invalidAlphaNumeric: true };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/validation.service.ts